import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Materia } from '../../../../models/materia';
import { MatPaginator } from '@angular/material/paginator';
import { MateriaComentario } from '../../../../models/comentario';
import { MateriaService } from '../../../../services/materia.service';
import { TemaService } from '../../../../services/tema.service';
import { UtilService } from '../../../../services/util.service';
import { MateriaComentarioService } from '../../../../services/materia.comentario.service';
import { MateriaComentarioRespostaService } from '../../../../services/materia.comentarioresposta.service';
import { DialogService } from '../../../../services/dialog.service';
import { ToastService } from '../../../../services/toast.service';
import { AuthService } from '../../../core/services/auth.service';
import { Tema } from '../../../../models/tema';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-materia',
  templateUrl: './adm-materia.component.html',
  styleUrls: ['./adm-materia.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmMateriaComponent implements OnInit {
  constructor(
    private authorizeService: AuthService,
    private modalService: NgbModal,
    private materiaService: MateriaService,
    private temaService: TemaService,
    private utilService: UtilService,
    private materiaComentarioService: MateriaComentarioService,
    private materiaComentarioRespostaService: MateriaComentarioRespostaService,
    private dialogService: DialogService,
    private toastService: ToastService,
    private router: Router
  ) { }

  displayedColumns: string[] = [
    'id',
    'tema',
    'titulo',
    'ativo',
    'data',
    'actions',
  ];
  dataSource: any = [];

  public temas: Tema[];
  public test: any;
  public materia: Materia;
  public newFile: File;
  public imagem: string;
  public comentariosMateria: MateriaComentario[];
  //usado para set da variável do diretório da imagem
  public editorData = '<p>Conteúdo inicial do editor</p>';
  public dataDir: string;

  //usado para listar os arquivos do diretório
  public arquivos: any;

  submitted = false;
  error = '';

  active: boolean = false;
  saving: boolean = false;
  loading: boolean = false;
  formMateria: UntypedFormGroup;
  formComentarioResposta: UntypedFormGroup;
  idComentario: number;

  settings = {
    columns: {
      id: {
        title: 'ID',
      },
      name: {
        title: 'Full Name',
      },
      username: {
        title: 'User Name',
      },
      email: {
        title: 'Email',
      },
    },
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user != null) {
      this.getTemas();
      this.loadGrid();
      this.createForm(new Materia());
    } else {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/adm/materia' }
      });
    }
  }

  get f() {
    return this.formMateria.controls;
  }

  loadGrid() {
    this.loading = true;
    this.materiaService.getAll().subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }

  getTemas() {
    this.temaService.get().subscribe((res) => {
      this.temas = res;
    });
  }

  createForm(materiaForm: Materia) {
    this.imagem = 'noFile.jpg';
    this.formMateria = new UntypedFormGroup({
      id: new UntypedFormControl(materiaForm.id),
      idTema: new UntypedFormControl(materiaForm.idTema),
      titulo: new UntypedFormControl(materiaForm.titulo),
      imagemDestaque: new UntypedFormControl(materiaForm.imagemDestaque),
      classeImagem: new UntypedFormControl(materiaForm.classeImagem),
      texto: new UntypedFormControl(materiaForm.texto),
      resumo: new UntypedFormControl(materiaForm.resumo),
      fonte: new UntypedFormControl(materiaForm.fonte),
      ativo: new UntypedFormControl((materiaForm.ativo = false)),
      permiteComentario: new UntypedFormControl(
        (materiaForm.permiteComentario = false)
      ),
      data: new UntypedFormControl(materiaForm.data),
    });
  }

  open(content: any) {
    this.materia = new Materia();
    this.createForm(this.materia);
    this.modalService.open(content, { size: 'lg' });
  }

  openComentarios(content: any, id: number) {
    this.modalService.open(content, { size: 'lg' });
    this.getComentarios(id);
  }

  openImagens(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, id: number) {
    this.submitted = false;
    this.materiaService.getById(id).subscribe((res) => {
      this.materia = res;
      this.dataDir = this.utilService.formatDateStr(
        new Date(this.materia.data)
      );
      this.imagem =
        this.materia.imagemDestaque != null && this.materia.imagemDestaque != ''
          ? this.dataDir + '/' + this.materia.imagemDestaque
          : 'noFile';
      this.formMateria.setValue({
        id: this.materia.id,
        idTema: this.materia.idTema,
        titulo: this.materia.titulo,
        imagemDestaque: this.materia.imagemDestaque,
        classeImagem: this.materia.classeImagem,
        texto: this.materia.texto,
        resumo: this.materia.resumo,
        fonte: this.materia.fonte,
        ativo: this.materia.ativo,
        permiteComentario: this.materia.permiteComentario,
        data: this.materia.data,
      });
    });
    this.modalService.open(content, { size: 'lg' });
  }

  async deleteItem(id: number): Promise<void> {
    this.active = true;
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.materiaService.delete(id).subscribe({
        next: () => {
          this.toastService.show('Excluído com sucesso', { type: 'success' });
          this.loadGrid();
        },
        error: (err) => {
          this.toastService.show('Erro ao excluir!', { type: 'danger' });
        },
      });
    }
  }

  async deleteImage(id: number): Promise<void> {
    this.active = true;
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.materiaService.deleteImage(id).subscribe(
        (res) => {
          this.toastService.show('Sucesso ao excluir', { type: 'success' });
          this.loadGrid();
        },
        (err) => {
          this.toastService.show('Erro ao excluir!', { type: 'danger' });
        }
      );
    }
  }

  create(content: any): void {
    this.createForm(this.materia);
    this.modalService.open(content);
  }

  prepareImage(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.newFile = files[0];
  }

  submitForm() {
    this.submitted = true;

    if (this.formMateria.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.materia = this.formMateria.value;

    if (this.newFile != null) {
      this.materia.imagemDestaque = this.newFile.name;
    }

    if (this.materia.id > 0) {
      this.materiaService.put(this.materia.id, this.materia).subscribe(
        (res) => {
          this.materia = res;
          this.loadGrid();
          this.toastService.show('Sucesso ao editar', { type: 'success' });
          this.modalService.dismissAll();
          if (this.newFile != null) {
            this.uploadImage(
              this.utilService.formatDateStr(new Date(this.materia.data))
            );
          }
        },
        (err) => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        }
      );
    } else {
      this.materia.id = 0;
      if (this.newFile != null) {
        this.uploadImage(this.utilService.formatDateStr(new Date()));
      }
      this.materia.data = new Date();
      this.materiaService.post(this.materia).subscribe({
        next: (res) => {
          this.toastService.show('Sucesso ao criar', { type: 'success' });
          this.loadGrid();
          this.modalService.dismissAll();
        },
        error: (err) => {
          this.toastService.show('Erro ao criar', { type: 'danger' });
        },
      });
    }
  }

  uploadImage(data: string) {
    this.utilService.upload(this.newFile, data).subscribe(
      (res) => {
        console.log(res);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getComentarios(id: number) {
    this.materiaComentarioService.getByMateriaId(id).subscribe({
      next: (res) => {
        this.comentariosMateria = res;
      },
      error: () => {
        this.comentariosMateria = [];
      },
    });
  }

  deleteComentario(id: number, idMateria: number) {
    this.materiaComentarioService.delete(id).subscribe({
      next: () => {
        this.getComentarios(idMateria);
        this.toastService.show('Sucesso ao excluir', { type: 'success' });
      },
    });
  }

  createFormResposta(materiaRespostaForm: ComentarioResposta) {
    this.formComentarioResposta = new UntypedFormGroup({
      id: new UntypedFormControl((materiaRespostaForm.id = 0)),
      idComentario: new UntypedFormControl(
        (materiaRespostaForm.idComentario = this.idComentario)
      ),
      resposta: new UntypedFormControl(materiaRespostaForm.resposta),
    });
  }

  openRespostaComentario(content: any, idComentario: number) {
    this.modalService.open(content);
    this.idComentario = idComentario;
    this.createFormResposta(new ComentarioResposta());
  }

  submitFormResposta() {
    var resp = this.formComentarioResposta.value;

    this.materiaComentarioRespostaService.post(resp).subscribe({
      next: () => {
        this.toastService.show('Sucesso ao executar', { type: 'success' });
        this.modalService.activeInstances;
      },
      error: () => {
        this.toastService.show('Erro ao executar', { type: 'danger' });
      },
    });
  }

}


export class ComentarioResposta {
  id: number;
  idComentario: number;
  resposta: string;
}


